import React, { memo } from "react";
import { Overlay } from "../overlay/overlay";
import { OverlayProps } from "../overlay/overlay.types";
import { ProgressIndicator } from "./progress-indicator";
import { CSS_CLASSES } from "./progress-indicator-css-classes";
import { ProgressIndicatorProps } from "./progress-indicator.types";

type ProgressIndicatorOverlayToOverlayPassthroughProps = Pick<OverlayProps, "open">;

type ProgressIndicatorOverlayToProgressIndicatorPassthroughProps = Pick<
  ProgressIndicatorProps,
  "color" | "size" | "label" | "labelPlacement"
>;

export type ProgressIndicatorOverlayProps = ProgressIndicatorOverlayToOverlayPassthroughProps &
  ProgressIndicatorOverlayToProgressIndicatorPassthroughProps;

export const ProgressIndicatorOverlay = memo(
  ({ open, color, size, label, labelPlacement }: ProgressIndicatorOverlayProps) => (
    <Overlay
      open={open}
      closeOnEscapeKey={false}
      closeOnOutsideClick={false}
      clipContainer={true}
      className={CSS_CLASSES.PROGRESS_INDICATOR_OVERLAY}
    >
      <ProgressIndicator color={color} size={size} label={label} labelPlacement={labelPlacement} />
    </Overlay>
  )
);
ProgressIndicatorOverlay.displayName = "ProgressIndicatorOverlay";
